module.exports = __webpack_public_path__ + "static/media/teamDiff.d6ba7994.jpeg";